module.exports = __webpack_public_path__ + "static/028-2c2dd5348715f408a74a6942984ab359.jpg";